module.exports = __webpack_public_path__ + "img/btn-jump.28fbb579.png";